import { ChipProps } from "@mui/material";
import React from "react";

export enum StyledTagColor {
  Green = "green",
  BrightGreen = "brightGreen",
  Blue = "blue",
  Orange = "orange",
  LightBlue = "lightBlue",
  Grey = "grey",
  Yellow = "yellow",
  Pink = "pink",
  LightPink = "lightPink",
  LightGrey = "lightGrey",
  LightOpacityGrey = "lightOpacityGrey",
  Azure = "azure",
  LightRed = "lightRed",
  White = "white",
  Black = "black",
}

export enum StyledTextColor {
  LightGreen = "lightGreen",
  Blue = "blue",
  Green = "green",
  White = "white",
  Black = "black",
  Orange = "orange",
  Grey = "grey",
  LightRed = "lightRed",
  Azure = "azure",
}

export interface StyledTagProps extends ChipProps {
  tagColor?: StyledTagColor;
  textColor?: StyledTextColor;
  fontSize?: "default" | "small";
  avatar?: React.ReactElement;
  borderRadius?: number;
  clickable?: boolean;
  onClick?: React.MouseEventHandler<any>;
}

export interface StyledUserTagProps extends StyledTagProps {
  label: string;
  limitNumber?: number;
  numberOfLinkingUsers?: number;
  isLimited?: boolean;
}
